/* hcs-ship-journeys.js — evergreen runtime for the How Your Order Ships page
   (sections/hcs-ship-journeys.liquid): week strip, frozen ZIP estimator,
   fresh cadence panel. Live-order mode lives in hcs-ship-order.js, which
   consumes the window.hcsShipX namespace exported at the bottom.

   Date math transcribes scripts/lib/frozen-delivery.mjs and
   scripts/lib/fresh-delivery.mjs (both unit-tested). Keep in sync,
   including the holiday table. REFRESH ANNUALLY. */
(function () {
  if (window.hcsShipXInit) return;
  window.hcsShipXInit = true;

  var root = document.querySelector('[data-sx-root]');
  if (!root) return;

  var TZ = 'America/Denver';
  var TRANSIT_URL = root.getAttribute('data-transit-url');
  var ZIP_KEY = 'hcsFrozenZip';
  var CACHE_KEY = 'hcsFrozenTransitJSON';

  var HOLIDAYS = new Set([
    '2026-01-01','2026-01-19','2026-02-16','2026-05-25','2026-06-19',
    '2026-07-03','2026-07-04','2026-09-07','2026-10-12','2026-11-11','2026-11-26',
    '2026-11-27','2026-12-25',
    '2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-06-18',
    '2027-07-05','2027-09-06','2027-10-11','2027-11-11','2027-11-25',
    '2027-11-26','2027-12-24',
    '2028-01-17','2028-02-21','2028-05-29','2028-06-19','2028-07-04',
    '2028-09-04','2028-10-09','2028-11-10','2028-11-23','2028-11-24',
    '2028-12-25'
  ]);

  function now() {
    // Test hook: window.__hcsShipNow = new Date('2026-08-10T16:00:00Z');
    return window.__hcsShipNow ? new Date(window.__hcsShipNow) : new Date();
  }

  function isoDateInTZ(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(date);
    var get = function (t) {
      for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value;
      return '';
    };
    return get('year') + '-' + get('month') + '-' + get('day');
  }

  function weekdayInTZ(date) {
    var wk = new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short' }).format(date);
    return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(wk);
  }

  function isBusinessDay(date) {
    var d = weekdayInTZ(date);
    if (d === 0 || d === 6) return false;
    return !HOLIDAYS.has(isoDateInTZ(date));
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d = new Date(d.getTime() + 86400000);
      if (isBusinessDay(d)) added++;
    }
    return d;
  }

  function addDaysISO(isoDay, n) {
    var p = isoDay.split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n)).toISOString().slice(0, 10);
  }

  function dateAtMT(isoDay, hour, minute) {
    minute = minute || 0;
    var anchor = new Date(isoDay + 'T12:00:00Z');
    var anchorMtH = parseInt(new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour: '2-digit', hour12: false
    }).format(anchor), 10);
    var offsetHours = 12 - anchorMtH;
    var hh = String(hour + offsetHours).padStart(2, '0');
    var mm = String(minute).padStart(2, '0');
    return new Date(isoDay + 'T' + hh + ':' + mm + ':00Z');
  }

  function formatHuman(isoDay) {
    var parts = isoDay.split('-');
    var d = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2], 12, 0, 0));
    return new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric'
    }).format(d);
  }

  function formatCountdown(ms) {
    if (ms <= 0) return '0h 0m';
    var totalSec = Math.floor(ms / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    if (h >= 24) return Math.floor(h / 24) + 'd ' + (h % 24) + 'h ' + m + 'm';
    if (h > 0) return h + 'h ' + m + 'm';
    return m + 'm ' + s + 's';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
    });
  }

  // Frozen plan (mirror of scripts/lib/frozen-delivery.mjs). Ships Tue and Wed only: 3-day Economy
  // zones Tue only; 1- and 2-day Economy and Overnight the first Tue or Wed whose 2 AM MT cutoff is
  // ahead. 3-day zones ship Overnight only when the ship date falls Jun 1 - Sep 30 (Preston 2026-10-23).
  var SUMMER_START = '06-01', SUMMER_END = '09-30';
  function isSummerOvernight(isoDay) {
    var md = isoDay.slice(5);
    return md >= SUMMER_START && md <= SUMMER_END;
  }

  function nextShipDay(when, dows) {
    var d = new Date(when);
    for (var i = 0; i < 21; i++) {
      if (dows.indexOf(weekdayInTZ(d)) !== -1 && isBusinessDay(d)) {
        var iso = isoDateInTZ(d);
        var cutoff = dateAtMT(iso, 2, 0);
        if (when < cutoff) return { ship: iso, cutoff: cutoff };
      }
      d = new Date(d.getTime() + 86400000);
    }
    return null;
  }

  function planOvernight(when) {
    var n = nextShipDay(when, [2, 3]);
    var arrival = isoDateInTZ(addBusinessDays(new Date(n.ship + 'T12:00:00Z'), 1));
    return { shipDate: n.ship, arrival: arrival, cutoff: n.cutoff };
  }

  function planEconomy(when, transitDays) {
    var n = nextShipDay(when, transitDays === 3 ? [2] : [2, 3]);
    var ship = n.ship, cutoff = n.cutoff;
    var earlyDate = addBusinessDays(new Date(ship + 'T12:00:00Z'), transitDays);
    var earlyISO = isoDateInTZ(earlyDate);
    var lateISO = transitDays === 1 ? earlyISO : isoDateInTZ(addBusinessDays(earlyDate, 1));
    return { shipDate: ship, arrivalStart: earlyISO, arrivalEnd: lateISO, cutoff: cutoff, transitDays: transitDays };
  }

  // Fresh plan (mirror of scripts/lib/fresh-delivery.mjs)
  function planFresh(when) {
    var d = new Date(when);
    var shipDate = null;
    for (var i = 0; i < 8; i++) {
      if (weekdayInTZ(d) === 3) { shipDate = isoDateInTZ(d); break; }
      d = new Date(d.getTime() + 86400000);
    }
    var cutoff = dateAtMT(addDaysISO(shipDate, -5), 16, 0);
    if (when >= cutoff) {
      shipDate = addDaysISO(shipDate, 7);
      cutoff = dateAtMT(addDaysISO(shipDate, -5), 16, 0);
    }
    return {
      shipDate: shipDate, cutoff: cutoff,
      arrivalOvernight: addDaysISO(shipDate, 1),
      arrivalTwoDay: addDaysISO(shipDate, 2)
    };
  }

  // Week strip: fill dates, mark today, ghost federal holidays.
  (function weekStrip() {
    var when = now();
    var todayISO = isoDateInTZ(when);
    var todayDow = weekdayInTZ(when);
    var backDays = todayDow === 0 ? 6 : todayDow - 1;
    var mondayISO = addDaysISO(todayISO, -backDays);
    var dows = [1, 2, 3, 4, 5, 6, 0];
    for (var i = 0; i < dows.length; i++) {
      var iso = addDaysISO(mondayISO, i);
      var cell = root.querySelector('.hcs-shipx__day[data-dow="' + dows[i] + '"]');
      if (!cell) continue;
      var el = cell.querySelector('[data-sx-date]');
      if (el) {
        el.textContent = new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: 'numeric' }).format(new Date(iso + 'T12:00:00Z'));
        el.hidden = false;
      }
      if (iso === todayISO) cell.setAttribute('data-today', '');
      if (HOLIDAYS.has(iso)) {
        // Nothing ships on a federal holiday: replace the dots with a
        // visible label so the strip never contradicts the estimator.
        cell.setAttribute('data-holiday', '');
        var dots = cell.querySelector('.hcs-shipx__day-dots');
        if (dots) dots.innerHTML = '<span class="hcs-shipx__day-holiday">Holiday</span>';
      }
    }
    var todayEl = root.querySelector('[data-sx-today]');
    if (todayEl) {
      todayEl.innerHTML = 'Today is <strong>' + escapeHtml(formatHuman(todayISO)) + '</strong>';
      todayEl.hidden = false;
    }
  })();

  // Frozen ZIP estimator
  var _transit = null;
  function loadTransit() {
    if (_transit) return Promise.resolve(_transit);
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) { _transit = JSON.parse(cached); return Promise.resolve(_transit); }
    } catch (e) { /* sessionStorage unavailable */ }
    return fetch(TRANSIT_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (json) {
        _transit = json;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(json)); } catch (e) {}
        return json;
      });
  }

  var _estInterval = null;
  function stopEstCountdown() {
    if (_estInterval) { clearInterval(_estInterval); _estInterval = null; }
  }

  function tickEstCountdown() {
    stopEstCountdown();
    var chip = root.querySelector('[data-sx-est-countdown]');
    if (!chip) return;
    var cutoff = new Date(chip.getAttribute('data-cutoff'));
    var text = chip.querySelector('[data-sx-est-countdown-text]');
    function update() {
      var ms = cutoff.getTime() - now().getTime();
      if (ms <= 0) {
        chip.textContent = '⏱ Cutoff passed. See next ship day above.';
        stopEstCountdown();
        return;
      }
      if (text) text.textContent = formatCountdown(ms);
    }
    update();
    _estInterval = setInterval(update, 1000);
  }

  function renderEstimate(zip, transit) {
    var resultEl = root.querySelector('[data-sx-est-result]');
    var formEl = root.querySelector('[data-sx-est-form]');
    if (!resultEl || !formEl) return;
    var when = now();
    var html;
    var editBtn = '<button type="button" class="hcs-shipx__zip-edit" data-sx-zip-edit>Change ZIP (' + escapeHtml(zip) + ')</button>';
    var summer3 = transit === 3 && isSummerOvernight(planEconomy(when, 3).shipDate);
    if (transit === 'ON' || summer3) {
      var p = planOvernight(when);
      html =
        (summer3
          ? '<p class="hcs-shipx__result-primary">From June 1 to September 30 your area ships <strong>Overnight only</strong>, so your chile arrives frozen in the summer heat.</p>'
          : '<p class="hcs-shipx__result-primary">Your area ships <strong>Overnight only</strong>. We won\'t risk ground transit over 3 days with dry ice.</p>') +
        '<p class="hcs-shipx__result-alt">Ships <strong>' + formatHuman(p.shipDate) + '</strong> &middot; arrives <strong>' + formatHuman(p.arrival) + '</strong></p>' +
        '<div class="hcs-shipx__cta-row">' +
          '<span class="hcs-shipx__countdown" data-sx-est-countdown data-cutoff="' + p.cutoff.toISOString() + '">⏱ Order in <span data-sx-est-countdown-text></span></span>' +
          '<span class="hcs-shipx__cta-context">to make this week\'s shipment.</span>' + editBtn +
        '</div>';
    } else if (transit === 1 || transit === 2 || transit === 3) {
      var econ = planEconomy(when, transit);
      var ovn = planOvernight(when);
      var arrival = econ.arrivalStart === econ.arrivalEnd
        ? '<strong>' + formatHuman(econ.arrivalStart) + '</strong>'
        : '<strong>' + formatHuman(econ.arrivalStart) + ' – ' + formatHuman(econ.arrivalEnd) + '</strong>';
      var shipDow = formatHuman(econ.shipDate).split(',')[0];
      html =
        '<p class="hcs-shipx__result-primary">Ships <strong>' + formatHuman(econ.shipDate) + '</strong> &middot; arrives ' + arrival + ' (Economy, ' + econ.transitDays + ' day' + (econ.transitDays === 1 ? '' : 's') + ')</p>' +
        '<p class="hcs-shipx__result-alt">Or pick <strong>Overnight</strong> at checkout: ships <strong>' + formatHuman(ovn.shipDate) + '</strong> &middot; arrives <strong>' + formatHuman(ovn.arrival) + '</strong></p>' +
        '<div class="hcs-shipx__cta-row">' +
          '<span class="hcs-shipx__countdown" data-sx-est-countdown data-cutoff="' + econ.cutoff.toISOString() + '">⏱ Order in <span data-sx-est-countdown-text></span></span>' +
          '<span class="hcs-shipx__cta-context">to make this week\'s ' + shipDow + ' shipment.</span>' + editBtn +
        '</div>';
    } else {
      html =
        '<p class="hcs-shipx__result-primary">We couldn\'t find ZIP <strong>' + escapeHtml(zip) + '</strong>.</p>' +
        '<p class="hcs-shipx__result-alt">Please check the ZIP, or contact us. Many remote ZIPs are Overnight only.</p>' +
        '<div class="hcs-shipx__cta-row">' + editBtn + '</div>';
    }
    resultEl.innerHTML = html;
    resultEl.hidden = false;
    formEl.hidden = true;
    tickEstCountdown();
  }

  function showZipError() {
    // Announced via the result region's aria-live="polite"; the form stays
    // visible so the field can be corrected in place.
    var resultEl = root.querySelector('[data-sx-est-result]');
    if (!resultEl) return;
    stopEstCountdown();
    resultEl.innerHTML = '<p class="hcs-shipx__result-primary">ZIP code needs 5 digits. Example: 87937.</p>';
    resultEl.hidden = false;
  }

  function showEstForm() {
    var resultEl = root.querySelector('[data-sx-est-result]');
    var formEl = root.querySelector('[data-sx-est-form]');
    stopEstCountdown();
    if (resultEl) { resultEl.hidden = true; resultEl.innerHTML = ''; }
    if (formEl) {
      formEl.hidden = false;
      var input = formEl.querySelector('[data-sx-zip-input]');
      if (input) { input.value = ''; input.focus(); }
    }
  }

  function submitZip(zip, quiet) {
    if (!/^\d{5}$/.test(zip)) {
      if (!quiet) showZipError();
      return;
    }
    loadTransit().then(function (data) {
      try { localStorage.setItem(ZIP_KEY, zip); } catch (e) {}
      var transit = Object.prototype.hasOwnProperty.call(data, zip) ? data[zip] : null;
      renderEstimate(zip, transit);
    }).catch(function (err) {
      console.warn('[hcs-shipx] transit data load failed', err);
      var resultEl = root.querySelector('[data-sx-est-result]');
      if (resultEl) {
        stopEstCountdown();
        resultEl.innerHTML = '<p class="hcs-shipx__result-primary">We couldn\'t load shipping data right now. Please refresh.</p>';
        resultEl.hidden = false;
      }
    });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sx-zip-submit]')) {
      var input = root.querySelector('[data-sx-zip-input]');
      if (input) submitZip(input.value.trim());
      return;
    }
    if (e.target.closest('[data-sx-zip-edit]')) {
      try { localStorage.removeItem(ZIP_KEY); } catch (e2) {}
      showEstForm();
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-sx-zip-input]');
    if (input) { e.preventDefault(); submitZip(input.value.trim()); }
  });

  root.addEventListener('input', function (e) {
    var input = e.target.closest('[data-sx-zip-input]');
    if (!input) return;
    input.value = input.value.replace(/\D/g, '').slice(0, 5);
    if (input.value.length === 5) submitZip(input.value);
  });

  // Returning visitor with a saved ZIP gets an instant answer.
  (function autofillZip() {
    if (!root.querySelector('[data-sx-est]')) return;
    var saved = null;
    try { saved = localStorage.getItem(ZIP_KEY); } catch (e) {}
    if (saved && /^\d{5}$/.test(saved)) submitZip(saved, true);
  })();

  // Fresh cadence panel
  (function freshCadence() {
    var panel = root.querySelector('[data-sx-fresh-cadence]');
    if (!panel) return; // preorder phase is fully server-rendered
    var plan = planFresh(now());
    var shipEl = panel.querySelector('[data-sx-fresh-shipdate]');
    var ovnEl = panel.querySelector('[data-sx-fresh-overnight]');
    if (shipEl) shipEl.textContent = formatHuman(plan.shipDate);
    if (ovnEl) ovnEl.textContent = formatHuman(plan.arrivalOvernight);
    var chip = panel.querySelector('[data-sx-fresh-countdown]');
    if (!chip) return;
    var text = chip.querySelector('[data-sx-fresh-countdown-text]');
    function update() {
      var ms = plan.cutoff.getTime() - now().getTime();
      if (ms <= 0) {
        chip.textContent = '⏱ Cutoff passed. See next ship day above.';
        clearInterval(id);
        return;
      }
      if (text) text.textContent = formatCountdown(ms);
    }
    update();
    var id = setInterval(update, 1000);
  })();

  // Shared helpers for hcs-ship-order.js (loads after this file, both defer).
  window.hcsShipX = {
    root: root,
    now: now,
    isoDateInTZ: isoDateInTZ,
    formatHuman: formatHuman,
    escapeHtml: escapeHtml
  };
})();
